<a
  [href]="href"
  [target]="target"
  (click)="click($event)">
  {{ text }}
</a>
